'use client'

import { useEffect } from 'react'

import ErrorModule from "@/error-module/ErrorModule"
import { ErrorModuleProps } from "@/error-module/ErrorModule.schema"
import { BackgroundColor } from '@/constants/constants'

import { ForbiddenError, NotFoundError } from "@/app/utils/errors"
import { useTranslations } from "@/lib/context/TranslationsContext"
import { t } from "@/lib/utils/helpers"

type ErrorType = 'generic' | '404' | 'forbidden'

export interface CustomErrorProps {
    error: Error & { digest?: string },
    reset: () => void
}

function Error(props: CustomErrorProps) {
    const { errorPages } = useTranslations()
    const locale = 'en';

    let type: ErrorType = 'generic'
    let errorMessage = `Error 500 - ${t(errorPages[type].errorMessage, locale)}`
    let backgroundColor: BackgroundColor = 'red'

    if (props.error.message === NotFoundError.message) {
        type = '404'
        errorMessage = `Error 404 - ${t(errorPages[type].errorMessage, locale)}`
        backgroundColor = 'yellow'
    } else if (props.error.message === ForbiddenError.message) {
        type = 'forbidden'
        errorMessage = `Error 403 - ${t(errorPages[type].errorMessage, locale)}`
        backgroundColor = 'purple'
    }

    const generalProps: ErrorModuleProps = {
        title: t(errorPages[type].title, locale),
        description: t(errorPages[type].description, locale),
        errorMessage: errorMessage || '',
        errorDescription: props.error.message || '',
        showLogo: type === 'generic',
        button: {
            label: t(errorPages.button.label, locale),
            url: `/`,
            size: 'large'
        },
        image: {
            url: errorPages[type].image.url,
            alternativeText: t(errorPages.image.alt, locale)
        },
        options: {
            backgroundColor
        }
    }

    useEffect(() => {
        // @ts-ignore
        if (window.newrelic) {
            // @ts-ignore
            window.newrelic.noticeError(props.error, {
                name: props.error.name,
                cause: props.error.cause,
                message: props.error.message
            })
        }
    }, [props.error])

    return (
        <>
            <title>Inzmo | Not Found</title>
            <ErrorModule {...generalProps} />
        </>
    )
}

export default Error